export default __webpack_public_path__ + "static/media/bathroom1-before-1440w.b9383f7d.webp";